// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Option-module__font-s-10___gg8rF {
  font-size: 10px !important;
}

.Option-module__font-s-12___TxAHe {
  font-size: 12px !important;
}

.Option-module__font-s-13___uoGn4 {
  font-size: 13px !important;
}

.Option-module__font-s-14___TH1wA {
  font-size: 14px !important;
}

.Option-module__font-s-15___wrLAJ {
  font-size: 15px !important;
}

.Option-module__font-s-16___Yo428 {
  font-size: 16px !important;
}

.Option-module__font-s-18___DDeUy {
  font-size: 18px !important;
}

.Option-module__font-s-20___gc0nJ {
  font-size: 20px !important;
}

.Option-module__font-s-22___TyFb0 {
  font-size: 22px !important;
}

.Option-module__font-s-28___Lwdrx {
  font-size: 28px !important;
}

.Option-module__font-w-400___Xxym5 {
  font-weight: 400 !important;
}

.Option-module__font-w-500___kQKuM {
  font-weight: 500 !important;
}

.Option-module__font-w-600___imHlM {
  font-weight: 600 !important;
}

.Option-module__font-w-700___dhicY {
  font-weight: 700 !important;
}

.Option-module__p-5___FmmpF {
  padding: 5px !important;
}

.Option-module__p-12___vcRPl {
  padding: 12px !important;
}

.Option-module__p-16___IrZaV {
  padding: 16px !important;
}

.Option-module__p-30___pCQJC {
  padding: 30px !important;
}

.Option-module__p-b-0___hHZXq {
  padding-bottom: 0 !important;
}

.Option-module__p-b-5___j2zV8 {
  padding-bottom: 5px !important;
}

.Option-module__p-b-10___xJCdo {
  padding-bottom: 10px !important;
}

.Option-module__p-b-12___jBBpY {
  padding-bottom: 12px !important;
}

.Option-module__p-b-16___kDO_E {
  padding-bottom: 16px !important;
}

.Option-module__p-b-18___X8K2t {
  padding-bottom: 18px !important;
}

.Option-module__p-b-20___jfx0v {
  padding-bottom: 20px !important;
}

.Option-module__p-b-25___CKXgX {
  padding-bottom: 25px !important;
}

.Option-module__p-b-30___Txqhu {
  padding-bottom: 30px !important;
}

.Option-module__p-b-50___zI3J2 {
  padding-bottom: 50px !important;
}

.Option-module__p-t-0___AKTV5 {
  padding-top: 0 !important;
}

.Option-module__p-t-12___LOiQX {
  padding-top: 12px !important;
}

.Option-module__p-t-16___ysmcu {
  padding-top: 16px !important;
}

.Option-module__p-t-18___iiNGl {
  padding-top: 18px !important;
}

.Option-module__p-t-20___zMAtA {
  padding-top: 20px !important;
}

.Option-module__p-t-30___uKUmX {
  padding-top: 30px !important;
}

.Option-module__p-t-40___TgodB {
  padding-top: 40px !important;
}

.Option-module__p-t-50___pDuJS {
  padding-top: 50px !important;
}

.Option-module__p-l-20___OmgSR {
  padding-left: 20px !important;
}

.Option-module__p-l-30___bRcuR {
  padding-left: 30px !important;
}

.Option-module__p-l-40___XIi5V {
  padding-left: 40px !important;
}

.Option-module__p-r-16___YJ34F {
  padding-right: 16px !important;
}

.Option-module__p-r-20___iXYOx {
  padding-right: 20px !important;
}

.Option-module__p-r-30___decMg {
  padding-right: 30px !important;
}

.Option-module__p-r-50___vuyji {
  padding-right: 50px !important;
}

.Option-module__p-r-60___VSalO {
  padding-right: 60px !important;
}

.Option-module__m-b-1___mZWb2 {
  margin-bottom: 1px !important;
}

.Option-module__m-b-2___skerg {
  margin-bottom: 2px !important;
}

.Option-module__m-b-6___u25h6 {
  margin-bottom: 6px !important;
}

.Option-module__m-b-8___MLkBe {
  margin-bottom: 8px !important;
}

.Option-module__m-b-10___BeWbT {
  margin-bottom: 10px !important;
}

.Option-module__m-b-14___g2MEn {
  margin-bottom: 14px !important;
}

.Option-module__m-b-16___wUebJ {
  margin-bottom: 16px !important;
}

.Option-module__m-b-20___Uhge9 {
  margin-bottom: 20px !important;
}

.Option-module__m-b-22___wSGHq {
  margin-bottom: 22px !important;
}

.Option-module__m-b-24___ebVTY {
  margin-bottom: 24px !important;
}

.Option-module__m-b-30___KOHmN {
  margin-bottom: 30px !important;
}

.Option-module__m-b-32___MOZ6T {
  margin-bottom: 32px !important;
}

.Option-module__m-b-40___xKgyU {
  margin-bottom: 40px !important;
}

.Option-module__m-t-2___ihQ1v {
  margin-top: 2px !important;
}

.Option-module__m-t-3___q3p86 {
  margin-top: 3px !important;
}

.Option-module__m-t-4___TulY0 {
  margin-top: 4px !important;
}

.Option-module__m-t-5___iL_ha {
  margin-top: 5px !important;
}

.Option-module__m-t-8___KJvY6 {
  margin-top: 8px !important;
}

.Option-module__m-t-10___TFKId {
  margin-top: 10px !important;
}

.Option-module__m-t-15___usr7p {
  margin-top: 15px !important;
}

.Option-module__m-t-16___G60Zi {
  margin-top: 16px !important;
}

.Option-module__m-t-20___RKXME {
  margin-top: 20px !important;
}

.Option-module__m-t-22___Usj8l {
  margin-top: 22px !important;
}

.Option-module__m-t-30___pw_wY {
  margin-top: 30px !important;
}

.Option-module__m-t-32___LNmBW {
  margin-top: 32px !important;
}

.Option-module__m-l-auto___j34xh {
  margin-left: auto !important;
}

.Option-module__m-l-4___2AK_1 {
  margin-left: 4px !important;
}

.Option-module__m-l-5___vHqDa {
  margin-left: 5px !important;
}

.Option-module__m-l-6___r8BaR {
  margin-left: 6px !important;
}

.Option-module__m-l-8___jYEHD {
  margin-left: 8px !important;
}

.Option-module__m-l-10___K2BV8 {
  margin-left: 10px !important;
}

.Option-module__m-l-16___UZ0NK {
  margin-left: 16px !important;
}

.Option-module__m-l-20___iec6K {
  margin-left: 20px !important;
}

.Option-module__m-l-24___hPesj {
  margin-left: 24px !important;
}

.Option-module__m-l-30___IN647 {
  margin-left: 30px !important;
}

.Option-module__m-l-35___y3fen {
  margin-left: 35px !important;
}

.Option-module__m-l-40___uQZu0 {
  margin-left: 40px !important;
}

.Option-module__m-r-8____sQ45 {
  margin-right: 8px !important;
}

.Option-module__m-r-10___LIjvD {
  margin-right: 10px !important;
}

.Option-module__m-r-16___WdXgr {
  margin-right: 16px !important;
}

.Option-module__m-r-20___X5oof {
  margin-right: 20px !important;
}

.Option-module__m-r-24___DmXFp {
  margin-right: 24px !important;
}

.Option-module__m-r-30___wkAJ2 {
  margin-right: 30px !important;
}

.Option-module__m-r-40___J1_DU {
  margin-right: 40px !important;
}

.Option-module__border-r-3___ZJU1n {
  border-radius: 3px !important;
}

.Option-module__border-r-4___zXiWf {
  border-radius: 4px !important;
}

.Option-module__border-r-6___jlXl7 {
  border-radius: 6px !important;
}

.Option-module__border-r-10___WB_AS {
  border-radius: 10px !important;
}

.Option-module__border-r-12___cRdQz {
  border-radius: 12px !important;
}

.Option-module__border-r-16___d5vag {
  border-radius: 16px !important;
}

.Option-module__border-r-50___kU9rw {
  border-radius: 50% !important;
}

.Option-module__primary-border___otMMm {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Option-module__primary-border-b___W9DrC {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Option-module__primary-border-t____jqGw {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Option-module__primary-border-l____b95N {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Option-module__primary-border-r___ubFzV {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Option-module__secondary-border___lN82Z {
  border: 1px solid #637768;
}

.Option-module__secondary-border-b___K9lug {
  border-bottom: 1px solid #637768;
}

.Option-module__secondary-border-t___aQoRe {
  border-top: 1px solid #637768;
}

.Option-module__secondary-border-l___rzh8h {
  border-left: 1px solid #637768;
}

.Option-module__secondary-border-r___DdX4t {
  border-right: 1px solid #637768;
}

.Option-module__gap-0___D17PK {
  gap: 0 !important;
}

.Option-module__gap-2___A4FZb {
  gap: 2px !important;
}

.Option-module__gap-4___gMC4j {
  gap: 4px !important;
}

.Option-module__gap-5___PU7mY {
  gap: 5px !important;
}

.Option-module__gap-6___V6MnP {
  gap: 6px !important;
}

.Option-module__gap-8___P8DOT {
  gap: 8px !important;
}

.Option-module__gap-10___gSjnL {
  gap: 10px !important;
}

.Option-module__gap-12___fJ4i7 {
  gap: 12px !important;
}

.Option-module__gap-14___e2zG2 {
  gap: 14px !important;
}

.Option-module__gap-16___B5v5h {
  gap: 16px !important;
}

.Option-module__gap-18___M9vzH {
  gap: 18px !important;
}

.Option-module__gap-20___rNnZs {
  gap: 20px !important;
}

.Option-module__gap-24___u52fO {
  gap: 24px !important;
}

.Option-module__gap-26___ODCFE {
  gap: 26px !important;
}

.Option-module__gap-30___EtXY5 {
  gap: 30px !important;
}

.Option-module__gap-32___mcCcU {
  gap: 32px !important;
}

.Option-module__gap-40___d7b2m {
  gap: 40px !important;
}

.Option-module__gap-50___t9R1l {
  gap: 50px !important;
}

.Option-module__flex-1___gtHgc {
  flex: 1;
}

.Option-module__flex-none___ybDyV {
  flex: none !important;
}

.Option-module__flex-column___xcOX1 {
  display: flex;
  flex-direction: column !important;
}

.Option-module__flex-row___SACzb {
  display: flex;
  flex-direction: row !important;
}

.Option-module__vertically-centered___q8nj9 {
  display: flex;
  align-items: center !important;
}

.Option-module__horizontally-centered___pfzAf {
  display: flex;
  justify-content: center !important;
}

.Option-module__horizontally-end___sN0W8 {
  display: flex;
  justify-content: end !important;
}

.Option-module__vertically-start___JeteF {
  display: flex;
  align-items: start !important;
}

.Option-module__space-between___dTB6E {
  display: flex;
  justify-content: space-between !important;
}

.Option-module__flex-wrap___kQWj7 {
  flex-wrap: wrap !important;
}

.Option-module__height-100___W9YiE {
  height: 100%;
}

.Option-module__width-50___c293i {
  width: 50% !important;
}

.Option-module__width-100___Ze6CS {
  width: 100%;
}

.Option-module__cursor-pointer___lGpdL {
  cursor: pointer;
}

.Option-module__cursor-not-allowed___WLMkc {
  cursor: not-allowed !important;
}

.Option-module__absolute-centered___W7IyC {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Option-module__absolute___btSjq {
  position: absolute;
}

.Option-module__relative___UGrJm {
  position: relative;
}

.Option-module__fixed___e_2VE {
  position: fixed;
}

.Option-module__visible___cDjtA {
  opacity: 1;
}

.Option-module__invisible___ZPUSW {
  opacity: 0;
}

.Option-module__col-90___LgoTI {
  width: 90% !important;
}

.Option-module__col-auto___TSFwN {
  width: auto !important;
}

.Option-module__medical-tabs___TkPOt {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Option-module__medical-table-new___bB_Xs {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Option-module__medical-table-new___bB_Xs:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Option-module__medical-table-new___bB_Xs::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Option-module__medical-table-new___bB_Xs::-webkit-scrollbar-track {
  display: none;
}
.Option-module__medical-table-new___bB_Xs.Option-module__no-pagination___d9R3y {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Option-module__medical-table-new___bB_Xs.Option-module__no-pagination___d9R3y:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Option-module__medical-table-new___bB_Xs.Option-module__no-pagination___d9R3y::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Option-module__medical-table-new___bB_Xs.Option-module__no-pagination___d9R3y::-webkit-scrollbar-track {
  display: none;
}

.Option-module__medical-table-empty___jX6Uw {
  padding: 14px 40px !important;
}

.Option-module__icon-btn___BhOLL {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Option-module__search-icon___CPjTy {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Option-module__disable-select___N3XVV {
  user-select: none;
}

.Option-module__break-word___Q3J2q {
  word-break: break-word;
}

.Option-module__popup-clear-btn___zFpSy {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Option-module__scroll-m-b-20___nHIxA {
  scroll-margin-bottom: 20px;
}

.Option-module__option___sj8S3 {
  color: #375844;
  word-break: break-word;
  cursor: pointer;
  padding: 12px;
  gap: 6px;
}
.Option-module__option___sj8S3:not(:last-child) {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}
.Option-module__option___sj8S3:hover, .Option-module__option___sj8S3.Option-module__selected___rCMHl {
  background-color: #f1f6f2;
}
.Option-module__option___sj8S3 .Option-module__icon___Jo_Bc {
  height: 12px;
  width: 12px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Select/Option/Option.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;AA8pBF;AA5pBE;EACE,8CAAA;AA8pBJ;AA3pBE;EAEE,yBAAA;AA4pBJ;AAzpBE;EACE,YAAA;EACA,WAAA;AA2pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.option {\n  color: get-color(greenNew, dark);\n  word-break: break-word;\n  cursor: pointer;\n  padding: 12px;\n  gap: 6px;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n  }\n\n  &:hover,\n  &.selected {\n    background-color: get-color(greenNew, ultra-light);\n  }\n\n  .icon {\n    height: 12px;\n    width: 12px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Option-module__font-s-10___gg8rF`,
	"fontS12": `Option-module__font-s-12___TxAHe`,
	"fontS13": `Option-module__font-s-13___uoGn4`,
	"fontS14": `Option-module__font-s-14___TH1wA`,
	"fontS15": `Option-module__font-s-15___wrLAJ`,
	"fontS16": `Option-module__font-s-16___Yo428`,
	"fontS18": `Option-module__font-s-18___DDeUy`,
	"fontS20": `Option-module__font-s-20___gc0nJ`,
	"fontS22": `Option-module__font-s-22___TyFb0`,
	"fontS28": `Option-module__font-s-28___Lwdrx`,
	"fontW400": `Option-module__font-w-400___Xxym5`,
	"fontW500": `Option-module__font-w-500___kQKuM`,
	"fontW600": `Option-module__font-w-600___imHlM`,
	"fontW700": `Option-module__font-w-700___dhicY`,
	"p5": `Option-module__p-5___FmmpF`,
	"p12": `Option-module__p-12___vcRPl`,
	"p16": `Option-module__p-16___IrZaV`,
	"p30": `Option-module__p-30___pCQJC`,
	"pB0": `Option-module__p-b-0___hHZXq`,
	"pB5": `Option-module__p-b-5___j2zV8`,
	"pB10": `Option-module__p-b-10___xJCdo`,
	"pB12": `Option-module__p-b-12___jBBpY`,
	"pB16": `Option-module__p-b-16___kDO_E`,
	"pB18": `Option-module__p-b-18___X8K2t`,
	"pB20": `Option-module__p-b-20___jfx0v`,
	"pB25": `Option-module__p-b-25___CKXgX`,
	"pB30": `Option-module__p-b-30___Txqhu`,
	"pB50": `Option-module__p-b-50___zI3J2`,
	"pT0": `Option-module__p-t-0___AKTV5`,
	"pT12": `Option-module__p-t-12___LOiQX`,
	"pT16": `Option-module__p-t-16___ysmcu`,
	"pT18": `Option-module__p-t-18___iiNGl`,
	"pT20": `Option-module__p-t-20___zMAtA`,
	"pT30": `Option-module__p-t-30___uKUmX`,
	"pT40": `Option-module__p-t-40___TgodB`,
	"pT50": `Option-module__p-t-50___pDuJS`,
	"pL20": `Option-module__p-l-20___OmgSR`,
	"pL30": `Option-module__p-l-30___bRcuR`,
	"pL40": `Option-module__p-l-40___XIi5V`,
	"pR16": `Option-module__p-r-16___YJ34F`,
	"pR20": `Option-module__p-r-20___iXYOx`,
	"pR30": `Option-module__p-r-30___decMg`,
	"pR50": `Option-module__p-r-50___vuyji`,
	"pR60": `Option-module__p-r-60___VSalO`,
	"mB1": `Option-module__m-b-1___mZWb2`,
	"mB2": `Option-module__m-b-2___skerg`,
	"mB6": `Option-module__m-b-6___u25h6`,
	"mB8": `Option-module__m-b-8___MLkBe`,
	"mB10": `Option-module__m-b-10___BeWbT`,
	"mB14": `Option-module__m-b-14___g2MEn`,
	"mB16": `Option-module__m-b-16___wUebJ`,
	"mB20": `Option-module__m-b-20___Uhge9`,
	"mB22": `Option-module__m-b-22___wSGHq`,
	"mB24": `Option-module__m-b-24___ebVTY`,
	"mB30": `Option-module__m-b-30___KOHmN`,
	"mB32": `Option-module__m-b-32___MOZ6T`,
	"mB40": `Option-module__m-b-40___xKgyU`,
	"mT2": `Option-module__m-t-2___ihQ1v`,
	"mT3": `Option-module__m-t-3___q3p86`,
	"mT4": `Option-module__m-t-4___TulY0`,
	"mT5": `Option-module__m-t-5___iL_ha`,
	"mT8": `Option-module__m-t-8___KJvY6`,
	"mT10": `Option-module__m-t-10___TFKId`,
	"mT15": `Option-module__m-t-15___usr7p`,
	"mT16": `Option-module__m-t-16___G60Zi`,
	"mT20": `Option-module__m-t-20___RKXME`,
	"mT22": `Option-module__m-t-22___Usj8l`,
	"mT30": `Option-module__m-t-30___pw_wY`,
	"mT32": `Option-module__m-t-32___LNmBW`,
	"mLAuto": `Option-module__m-l-auto___j34xh`,
	"mL4": `Option-module__m-l-4___2AK_1`,
	"mL5": `Option-module__m-l-5___vHqDa`,
	"mL6": `Option-module__m-l-6___r8BaR`,
	"mL8": `Option-module__m-l-8___jYEHD`,
	"mL10": `Option-module__m-l-10___K2BV8`,
	"mL16": `Option-module__m-l-16___UZ0NK`,
	"mL20": `Option-module__m-l-20___iec6K`,
	"mL24": `Option-module__m-l-24___hPesj`,
	"mL30": `Option-module__m-l-30___IN647`,
	"mL35": `Option-module__m-l-35___y3fen`,
	"mL40": `Option-module__m-l-40___uQZu0`,
	"mR8": `Option-module__m-r-8____sQ45`,
	"mR10": `Option-module__m-r-10___LIjvD`,
	"mR16": `Option-module__m-r-16___WdXgr`,
	"mR20": `Option-module__m-r-20___X5oof`,
	"mR24": `Option-module__m-r-24___DmXFp`,
	"mR30": `Option-module__m-r-30___wkAJ2`,
	"mR40": `Option-module__m-r-40___J1_DU`,
	"borderR3": `Option-module__border-r-3___ZJU1n`,
	"borderR4": `Option-module__border-r-4___zXiWf`,
	"borderR6": `Option-module__border-r-6___jlXl7`,
	"borderR10": `Option-module__border-r-10___WB_AS`,
	"borderR12": `Option-module__border-r-12___cRdQz`,
	"borderR16": `Option-module__border-r-16___d5vag`,
	"borderR50": `Option-module__border-r-50___kU9rw`,
	"primaryBorder": `Option-module__primary-border___otMMm`,
	"primaryBorderB": `Option-module__primary-border-b___W9DrC`,
	"primaryBorderT": `Option-module__primary-border-t____jqGw`,
	"primaryBorderL": `Option-module__primary-border-l____b95N`,
	"primaryBorderR": `Option-module__primary-border-r___ubFzV`,
	"secondaryBorder": `Option-module__secondary-border___lN82Z`,
	"secondaryBorderB": `Option-module__secondary-border-b___K9lug`,
	"secondaryBorderT": `Option-module__secondary-border-t___aQoRe`,
	"secondaryBorderL": `Option-module__secondary-border-l___rzh8h`,
	"secondaryBorderR": `Option-module__secondary-border-r___DdX4t`,
	"gap0": `Option-module__gap-0___D17PK`,
	"gap2": `Option-module__gap-2___A4FZb`,
	"gap4": `Option-module__gap-4___gMC4j`,
	"gap5": `Option-module__gap-5___PU7mY`,
	"gap6": `Option-module__gap-6___V6MnP`,
	"gap8": `Option-module__gap-8___P8DOT`,
	"gap10": `Option-module__gap-10___gSjnL`,
	"gap12": `Option-module__gap-12___fJ4i7`,
	"gap14": `Option-module__gap-14___e2zG2`,
	"gap16": `Option-module__gap-16___B5v5h`,
	"gap18": `Option-module__gap-18___M9vzH`,
	"gap20": `Option-module__gap-20___rNnZs`,
	"gap24": `Option-module__gap-24___u52fO`,
	"gap26": `Option-module__gap-26___ODCFE`,
	"gap30": `Option-module__gap-30___EtXY5`,
	"gap32": `Option-module__gap-32___mcCcU`,
	"gap40": `Option-module__gap-40___d7b2m`,
	"gap50": `Option-module__gap-50___t9R1l`,
	"flex1": `Option-module__flex-1___gtHgc`,
	"flexNone": `Option-module__flex-none___ybDyV`,
	"flexColumn": `Option-module__flex-column___xcOX1`,
	"flexRow": `Option-module__flex-row___SACzb`,
	"verticallyCentered": `Option-module__vertically-centered___q8nj9`,
	"horizontallyCentered": `Option-module__horizontally-centered___pfzAf`,
	"horizontallyEnd": `Option-module__horizontally-end___sN0W8`,
	"verticallyStart": `Option-module__vertically-start___JeteF`,
	"spaceBetween": `Option-module__space-between___dTB6E`,
	"flexWrap": `Option-module__flex-wrap___kQWj7`,
	"height100": `Option-module__height-100___W9YiE`,
	"width50": `Option-module__width-50___c293i`,
	"width100": `Option-module__width-100___Ze6CS`,
	"cursorPointer": `Option-module__cursor-pointer___lGpdL`,
	"cursorNotAllowed": `Option-module__cursor-not-allowed___WLMkc`,
	"absoluteCentered": `Option-module__absolute-centered___W7IyC`,
	"absolute": `Option-module__absolute___btSjq`,
	"relative": `Option-module__relative___UGrJm`,
	"fixed": `Option-module__fixed___e_2VE`,
	"visible": `Option-module__visible___cDjtA`,
	"invisible": `Option-module__invisible___ZPUSW`,
	"col90": `Option-module__col-90___LgoTI`,
	"colAuto": `Option-module__col-auto___TSFwN`,
	"medicalTabs": `Option-module__medical-tabs___TkPOt`,
	"medicalTableNew": `Option-module__medical-table-new___bB_Xs`,
	"noPagination": `Option-module__no-pagination___d9R3y`,
	"medicalTableEmpty": `Option-module__medical-table-empty___jX6Uw`,
	"iconBtn": `Option-module__icon-btn___BhOLL`,
	"searchIcon": `Option-module__search-icon___CPjTy`,
	"disableSelect": `Option-module__disable-select___N3XVV`,
	"breakWord": `Option-module__break-word___Q3J2q`,
	"popupClearBtn": `Option-module__popup-clear-btn___zFpSy`,
	"scrollMB20": `Option-module__scroll-m-b-20___nHIxA`,
	"option": `Option-module__option___sj8S3`,
	"selected": `Option-module__selected___rCMHl`,
	"icon": `Option-module__icon___Jo_Bc`
};
module.exports = ___CSS_LOADER_EXPORT___;
